import React from 'react'
import { Row, Table, ButtonGroup } from 'rsuite'
import TooltipButton from '../../components/buttons/TooltipButton'
const { Column, HeaderCell, Cell } = Table

export default function ScrutinizeAttachFiles({ data, onPreview, onDownload, onDelete, ...props }) {
  const { isEdit } = props

  return (
    <Row style={{ marginBottom: 20, marginTop: 10 }}>
      <Table height={300} wordWrap data={data}>
        <Column width={90} align="center" fixed>
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>
        <Column width={300} flexGrow={1}>
          <HeaderCell>ชื่อไฟล์</HeaderCell>
          <Cell dataKey="fileName" />
        </Column>

        <Column width={150} align="center" fixed="right">
          <HeaderCell></HeaderCell>
          <Cell>
            {(rowData, index) => {
              return (
                <ButtonGroup>
                  <TooltipButton
                    icon="eye"
                    tooltip={`แสดง`}
                    onClick={(e) => onPreview(rowData)}
                  ></TooltipButton>
                  <TooltipButton
                    icon="download"
                    tooltip={`ดาวน์โหลด`}
                    onClick={(e) => onDownload(rowData)}
                  ></TooltipButton>
                  {isEdit && (
                    <TooltipButton
                      icon="trash-o"
                      tooltip={`ลบ`}
                      onClick={() => onDelete(rowData, index)}
                    ></TooltipButton>
                  )}
                </ButtonGroup>
              )
            }}
          </Cell>
        </Column>
      </Table>
    </Row>
  )
}
